import { render } from "./AllNews.vue?vue&type=template&id=574e9685&scoped=true"
import script from "./AllNews.vue?vue&type=script&lang=js"
export * from "./AllNews.vue?vue&type=script&lang=js"

import "./AllNews.vue?vue&type=style&index=0&id=574e9685&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574e9685"]])

export default __exports__